// src/utils/labItemUtils.tsx

import React from 'react';
import { ExperimentOutlined, MedicineBoxOutlined, ShoppingOutlined } from '@ant-design/icons';

export const statusColors: { [key: string]: string } = {
  Draft: '#B0B0B0', // Light gray
  'Pending Test Approval': '#9A3823', // Dark red
  Approved: '#FF9D00', // Orange
  'Pending Test Results': '#A0522D', // Sienna
  Submitted: '#FF9D00', // Orange
  'Test Results Approved': '#4C9A2A', // Olive green
  'Pending Submission': '#9A3823', // Dark red
  'Pending Approval': '#C46210', // Burnt orange
  Complete: '#038C13', // Green
  'Pending Vaccine Approval': '#8B0000', // Dark red
  Manufactured: '#DAA520', // Goldenrod
  Pending: '#FF6347', // Tomato
  Ready: '#396AFF', // Blue
  Collected: '#228B22', // Forest green
  'Pending Product Approval': '',
};

export const getTestIcon = (type: string): React.ReactNode => {
  switch (type) {
    case 'Tests':
      return <ExperimentOutlined />;
    case 'Vaccines':
      return <MedicineBoxOutlined />;
    case 'Products':
      return <ShoppingOutlined />;
    default:
      return <ExperimentOutlined />;
  }
};

export const MainlabTaskStatusColors: { [key: string]: string } = {
  DRAFT: '#8c8c8c', // Gray
  PENDING_TA: '#d46b08', // Orange
  PENDING_PAYMENT: '#fa8c16', // Amber
  PENDING_ITR: '#1890ff', // Blue
  PENDING_ITRA: '#722ed1', // Purple
  PENDING_FRS: '#13c2c2', // Cyan
  PENDING_FA: '#eb2f96', // Magenta
  DONE: '#52c41a', // Green
  PENDING_MA: '#531dab', // Deep Purple
  PENDING_IA: '#eb4d4b', // Coral Red
  PENDING_COLLECTION: '#389e0d', // Forest Green
};
export const MainlabTaskStatusLabels: Record<string, string> = {
  DRAFT: 'DRAFT',
  PENDING_TA: 'PENDING TEST ASSIGNMENT',
  PENDING_PAYMENT: 'PENDING PAYMENT',
  PENDING_ITR: 'PENDING INITIAL TEST RESULTS',
  PENDING_ITRA: 'PENDING INITIAL TEST RESULTS APPROVAL',
  PENDING_FRS: 'PENDING FINAL RESULTS APPROVAL',
  PENDING_FA: 'PENDING FINAL APPROVAL',
  DONE: 'DONE',
  PENDING_MA: 'PENDING MANUFACTURE ASSIGNMENT',
  PENDING_IA: 'PENDING INITIAL APPROVAL',
  PENDING_COLLECTION: 'PENDING COLLECTION',
};
